/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CountGroups200Response } from '../models';
// @ts-ignore
import type { CreateGroup200Response } from '../models';
// @ts-ignore
import type { GetGroup200Response } from '../models';
// @ts-ignore
import type { GetGroupUsers200Response } from '../models';
// @ts-ignore
import type { GetMyGroups200Response } from '../models';
// @ts-ignore
import type { GlobalRoleAssignDTO } from '../models';
// @ts-ignore
import type { GroupCreateDTO } from '../models';
// @ts-ignore
import type { GroupUpdateDTO } from '../models';
// @ts-ignore
import type { ListGroups200Response } from '../models';
// @ts-ignore
import type { NexusAdoptChildPayload } from '../models';
// @ts-ignore
import type { SearchGroupsAdmin200Response } from '../models';
// @ts-ignore
import type { SortOrder } from '../models';
/**
 * NexusGroupApi - axios parameter creator
 */
export const NexusGroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} groupId 
         * @param {GlobalRoleAssignDTO} globalRoleAssignDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRolesToGroup: async (groupId: string, globalRoleAssignDTO: GlobalRoleAssignDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('assignRolesToGroup', 'groupId', groupId)
            // verify required parameter 'globalRoleAssignDTO' is not null or undefined
            assertParamExists('assignRolesToGroup', 'globalRoleAssignDTO', globalRoleAssignDTO)
            const localVarPath = `/api/nora/nexus/group/{groupId}/role/assign`
                .replace('{groupId}', encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(globalRoleAssignDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary countGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/group/admin/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary createGroup
         * @param {GroupCreateDTO} groupCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup: async (groupCreateDTO: GroupCreateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupCreateDTO' is not null or undefined
            assertParamExists('createGroup', 'groupCreateDTO', groupCreateDTO)
            const localVarPath = `/api/nora/nexus/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteGroup
         * @param {string} groupId 
         * @param {boolean} recursive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup: async (groupId: string, recursive: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('deleteGroup', 'groupId', groupId)
            // verify required parameter 'recursive' is not null or undefined
            assertParamExists('deleteGroup', 'recursive', recursive)
            const localVarPath = `/api/nora/nexus/group/{groupId}`
                .replace('{groupId}', encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (recursive !== undefined) {
                localVarQueryParameter['recursive'] = recursive;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getGroup
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getGroup', 'groupId', groupId)
            const localVarPath = `/api/nora/nexus/group/{groupId}`
                .replace('{groupId}', encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getGroupUsers
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupUsers: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getGroupUsers', 'groupId', groupId)
            const localVarPath = `/api/nora/nexus/group/{groupId}/users`
                .replace('{groupId}', encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getGroupsByUserId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsByUserId: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getGroupsByUserId', 'userId', userId)
            const localVarPath = `/api/nora/nexus/group/admin/user/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getMyGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/group/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary groupAdoptChild
         * @param {string} groupId 
         * @param {NexusAdoptChildPayload} nexusAdoptChildPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupAdoptChild: async (groupId: string, nexusAdoptChildPayload: NexusAdoptChildPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('groupAdoptChild', 'groupId', groupId)
            // verify required parameter 'nexusAdoptChildPayload' is not null or undefined
            assertParamExists('groupAdoptChild', 'nexusAdoptChildPayload', nexusAdoptChildPayload)
            const localVarPath = `/api/nora/nexus/group/{groupId}/adopt`
                .replace('{groupId}', encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nexusAdoptChildPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary listGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary searchGroupsAdmin
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroupsAdmin: async (query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/group/admin/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary searchGroupsV2
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroupsV2: async (query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/group/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateGroup
         * @param {string} groupId 
         * @param {GroupUpdateDTO} groupUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup: async (groupId: string, groupUpdateDTO: GroupUpdateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('updateGroup', 'groupId', groupId)
            // verify required parameter 'groupUpdateDTO' is not null or undefined
            assertParamExists('updateGroup', 'groupUpdateDTO', groupUpdateDTO)
            const localVarPath = `/api/nora/nexus/group/{groupId}`
                .replace('{groupId}', encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NexusGroupApi - functional programming interface
 */
export const NexusGroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NexusGroupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} groupId 
         * @param {GlobalRoleAssignDTO} globalRoleAssignDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignRolesToGroup(groupId: string, globalRoleAssignDTO: GlobalRoleAssignDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignRolesToGroup(groupId, globalRoleAssignDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.assignRolesToGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary countGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountGroups200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.countGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary createGroup
         * @param {GroupCreateDTO} groupCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroup(groupCreateDTO: GroupCreateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateGroup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGroup(groupCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.createGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deleteGroup
         * @param {string} groupId 
         * @param {boolean} recursive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroup(groupId: string, recursive: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroup(groupId, recursive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.deleteGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getGroup
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroup(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGroup200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroup(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.getGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getGroupUsers
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupUsers(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGroupUsers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupUsers(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.getGroupUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getGroupsByUserId
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupsByUserId(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListGroups200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupsByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.getGroupsByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getMyGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyGroups200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.getMyGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary groupAdoptChild
         * @param {string} groupId 
         * @param {NexusAdoptChildPayload} nexusAdoptChildPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupAdoptChild(groupId: string, nexusAdoptChildPayload: NexusAdoptChildPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupAdoptChild(groupId, nexusAdoptChildPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.groupAdoptChild']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary listGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListGroups200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.listGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary searchGroupsAdmin
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchGroupsAdmin(query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchGroupsAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchGroupsAdmin(query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.searchGroupsAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary searchGroupsV2
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchGroupsV2(query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchGroupsAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchGroupsV2(query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.searchGroupsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updateGroup
         * @param {string} groupId 
         * @param {GroupUpdateDTO} groupUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroup(groupId: string, groupUpdateDTO: GroupUpdateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroup(groupId, groupUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusGroupApi.updateGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NexusGroupApi - factory interface
 */
export const NexusGroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NexusGroupApiFp(configuration)
    return {
        /**
         * 
         * @param {NexusGroupApiAssignRolesToGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRolesToGroup(requestParameters: NexusGroupApiAssignRolesToGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.assignRolesToGroup(requestParameters.groupId, requestParameters.globalRoleAssignDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary countGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countGroups(options?: RawAxiosRequestConfig): AxiosPromise<CountGroups200Response> {
            return localVarFp.countGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary createGroup
         * @param {NexusGroupApiCreateGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(requestParameters: NexusGroupApiCreateGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateGroup200Response> {
            return localVarFp.createGroup(requestParameters.groupCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteGroup
         * @param {NexusGroupApiDeleteGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(requestParameters: NexusGroupApiDeleteGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteGroup(requestParameters.groupId, requestParameters.recursive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getGroup
         * @param {NexusGroupApiGetGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(requestParameters: NexusGroupApiGetGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetGroup200Response> {
            return localVarFp.getGroup(requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getGroupUsers
         * @param {NexusGroupApiGetGroupUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupUsers(requestParameters: NexusGroupApiGetGroupUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetGroupUsers200Response> {
            return localVarFp.getGroupUsers(requestParameters.groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getGroupsByUserId
         * @param {NexusGroupApiGetGroupsByUserIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsByUserId(requestParameters: NexusGroupApiGetGroupsByUserIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListGroups200Response> {
            return localVarFp.getGroupsByUserId(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getMyGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyGroups(options?: RawAxiosRequestConfig): AxiosPromise<GetMyGroups200Response> {
            return localVarFp.getMyGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary groupAdoptChild
         * @param {NexusGroupApiGroupAdoptChildRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupAdoptChild(requestParameters: NexusGroupApiGroupAdoptChildRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.groupAdoptChild(requestParameters.groupId, requestParameters.nexusAdoptChildPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary listGroups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroups(options?: RawAxiosRequestConfig): AxiosPromise<ListGroups200Response> {
            return localVarFp.listGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary searchGroupsAdmin
         * @param {NexusGroupApiSearchGroupsAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroupsAdmin(requestParameters: NexusGroupApiSearchGroupsAdminRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchGroupsAdmin200Response> {
            return localVarFp.searchGroupsAdmin(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary searchGroupsV2
         * @param {NexusGroupApiSearchGroupsV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroupsV2(requestParameters: NexusGroupApiSearchGroupsV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchGroupsAdmin200Response> {
            return localVarFp.searchGroupsV2(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateGroup
         * @param {NexusGroupApiUpdateGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(requestParameters: NexusGroupApiUpdateGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.updateGroup(requestParameters.groupId, requestParameters.groupUpdateDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for assignRolesToGroup operation in NexusGroupApi.
 */
export interface NexusGroupApiAssignRolesToGroupRequest {
    readonly groupId: string

    readonly globalRoleAssignDTO: GlobalRoleAssignDTO
}

/**
 * Request parameters for createGroup operation in NexusGroupApi.
 */
export interface NexusGroupApiCreateGroupRequest {
    readonly groupCreateDTO: GroupCreateDTO
}

/**
 * Request parameters for deleteGroup operation in NexusGroupApi.
 */
export interface NexusGroupApiDeleteGroupRequest {
    readonly groupId: string

    readonly recursive: boolean
}

/**
 * Request parameters for getGroup operation in NexusGroupApi.
 */
export interface NexusGroupApiGetGroupRequest {
    readonly groupId: string
}

/**
 * Request parameters for getGroupUsers operation in NexusGroupApi.
 */
export interface NexusGroupApiGetGroupUsersRequest {
    readonly groupId: string
}

/**
 * Request parameters for getGroupsByUserId operation in NexusGroupApi.
 */
export interface NexusGroupApiGetGroupsByUserIdRequest {
    readonly userId: string
}

/**
 * Request parameters for groupAdoptChild operation in NexusGroupApi.
 */
export interface NexusGroupApiGroupAdoptChildRequest {
    readonly groupId: string

    readonly nexusAdoptChildPayload: NexusAdoptChildPayload
}

/**
 * Request parameters for searchGroupsAdmin operation in NexusGroupApi.
 */
export interface NexusGroupApiSearchGroupsAdminRequest {
    readonly query?: string

    readonly filter?: string

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    readonly cursor?: string

    readonly sortBy?: string
}

/**
 * Request parameters for searchGroupsV2 operation in NexusGroupApi.
 */
export interface NexusGroupApiSearchGroupsV2Request {
    readonly query?: string

    readonly filter?: string

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    readonly cursor?: string

    readonly sortBy?: string
}

/**
 * Request parameters for updateGroup operation in NexusGroupApi.
 */
export interface NexusGroupApiUpdateGroupRequest {
    readonly groupId: string

    readonly groupUpdateDTO: GroupUpdateDTO
}

/**
 * NexusGroupApi - object-oriented interface
 */
export class NexusGroupApi extends BaseAPI {
    /**
     * 
     * @param {NexusGroupApiAssignRolesToGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignRolesToGroup(requestParameters: NexusGroupApiAssignRolesToGroupRequest, options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).assignRolesToGroup(requestParameters.groupId, requestParameters.globalRoleAssignDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary countGroups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public countGroups(options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).countGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary createGroup
     * @param {NexusGroupApiCreateGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createGroup(requestParameters: NexusGroupApiCreateGroupRequest, options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).createGroup(requestParameters.groupCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteGroup
     * @param {NexusGroupApiDeleteGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteGroup(requestParameters: NexusGroupApiDeleteGroupRequest, options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).deleteGroup(requestParameters.groupId, requestParameters.recursive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getGroup
     * @param {NexusGroupApiGetGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGroup(requestParameters: NexusGroupApiGetGroupRequest, options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).getGroup(requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getGroupUsers
     * @param {NexusGroupApiGetGroupUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGroupUsers(requestParameters: NexusGroupApiGetGroupUsersRequest, options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).getGroupUsers(requestParameters.groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getGroupsByUserId
     * @param {NexusGroupApiGetGroupsByUserIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGroupsByUserId(requestParameters: NexusGroupApiGetGroupsByUserIdRequest, options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).getGroupsByUserId(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getMyGroups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMyGroups(options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).getMyGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary groupAdoptChild
     * @param {NexusGroupApiGroupAdoptChildRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public groupAdoptChild(requestParameters: NexusGroupApiGroupAdoptChildRequest, options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).groupAdoptChild(requestParameters.groupId, requestParameters.nexusAdoptChildPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary listGroups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listGroups(options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).listGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary searchGroupsAdmin
     * @param {NexusGroupApiSearchGroupsAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchGroupsAdmin(requestParameters: NexusGroupApiSearchGroupsAdminRequest = {}, options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).searchGroupsAdmin(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary searchGroupsV2
     * @param {NexusGroupApiSearchGroupsV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchGroupsV2(requestParameters: NexusGroupApiSearchGroupsV2Request = {}, options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).searchGroupsV2(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateGroup
     * @param {NexusGroupApiUpdateGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateGroup(requestParameters: NexusGroupApiUpdateGroupRequest, options?: RawAxiosRequestConfig) {
        return NexusGroupApiFp(this.configuration).updateGroup(requestParameters.groupId, requestParameters.groupUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

